import Novedades from './novedades.vue';
import Error403 from './../403.vue';
import RoutesUtils from '../../js/RoutesUtils.js';
import Utils from '../../js/Utils.js';
import { conUsuarioActualizado } from '../../js/barreraUsuarioActualizado.js';

// Apartado Novedades (#250). Es para TODA la plantilla: el backend solo pide estar identificado
// (`NovedadesController.requireAutenticado`), sin recorte por rol.
//
// Por eso aquí NO hay lista de roles. Lo único que decide es el menú del usuario, que es el control
// de acceso real de las rutas en esta aplicación, y la entrada la escribe el lote de despliegue
// visible para todos los roles. Una lista de roles aquí sería un segundo criterio que diría lo mismo
// hoy y dejaría de decirlo el día que se dé de alta un rol nuevo.
//
// Entra por la barrera de usuario actualizado para que el menú con el que se decide sea el de ESTA
// carga y no el que quedó guardado de la sesión anterior: el porqué, en `barreraUsuarioActualizado.js`.
const routes = [
    {
        path: '/novedades/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: conUsuarioActualizado(function(routeTo) {
            // Si la ruta no está en el menú efectivo del usuario, no se pinta la pantalla: entrar por
            // URL a algo que no está en tu menú es lo que el resto de la aplicación resuelve con un
            // 403, y hacerlo distinto aquí sería una excepción sin motivo.
            //
            // Sin menú cargado se deja pasar, y es deliberado: no hay nada que proteger —la lectura
            // es de cualquier usuario autenticado— y negar la entrada por no haber podido leer el
            // menú dejaría la pantalla inalcanzable justo cuando el menú tarda.
            const menu = Utils.getMenu();
            if (menu && !RoutesUtils.isInMenu(menu, routeTo.path)) {
                return { component: Error403 };
            }
            return { component: Novedades };
        }),
        keepAlive: true
    }
];
export default routes;
